import { initials, markColor } from '@/lib/cobalt-helpers';
import { cn } from '@/lib/utils';

interface Props {
  /** Full company name; used to derive initials + stable color. */
  name: string | null | undefined;
  size?: number;
  className?: string;
}

/**
 * Squircle company avatar — colored tint background + colored initials.
 * Color is deterministic per name so 'Acme Industries' is always the same hue
 * everywhere in the app (table cell, detail header, mobile card).
 */
export function CompanyMark({ name, size = 26, className }: Props) {
  const rgb = markColor(name);   // 'r g b' triple
  const label = initials(name);
  return (
    <span
      aria-hidden="true"
      className={cn('inline-flex shrink-0 items-center justify-center font-semibold leading-none', className)}
      style={{
        width: size,
        height: size,
        borderRadius: Math.max(4, size * 0.22),
        background: `rgb(${rgb} / 0.16)`,
        color:      `color-mix(in srgb, rgb(${rgb}), white var(--mark-lift))`, // lifted for dark (index.css)
        fontSize:   Math.round(size * 0.42),
        letterSpacing: '0.02em',
      }}
    >
      {label}
    </span>
  );
}
